import * as $ from 'jquery';
import { apiBaseUrlAdmin, apiBaseUrlUser } from "../../../constants/url.constant";
import { DefaultService } from "../../common/services/DefaultService";

export class InvoicePrintService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/invoicePrint`;
    private baseUrlAdmin = `${apiBaseUrlAdmin}/invoicePrint`;

    public RouteGet = (id: string) => `${this.baseUrl}/get/${id}`;
    public get(id: string): JQueryPromise<any> {
        return $.ajax(this.RouteGet(id), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetGetForLabel = (ids: string) => `${this.baseUrlAdmin}/getForLabel/${ids}`;
    public getForLabel(ids: string): JQueryPromise<any> {
        return $.ajax(this.RouteGetGetForLabel(ids), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}